"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseProcesses = void 0;
const index_1 = require("../../Model/index");
const TypeFactory_1 = require("../TypeFactory");
const index_2 = require("./index");
function parseProcesses(rawProcessDefinition) {
    const rawProcesses = (0, TypeFactory_1.getModelPropertyAsArray)(rawProcessDefinition, index_1.BpmnTags.CommonElement.Process);
    if (!rawProcesses) {
        return [];
    }
    return rawProcesses.map((rawProcess) => {
        const processModelId = rawProcess.id;
        try {
            const process = (0, TypeFactory_1.createObjectWithCommonProperties)(rawProcess, index_1.Model.Process);
            process.name = rawProcess.name;
            process.isExecutable = rawProcess.isExecutable === 'true';
            const bpmnErrors = parseProcessModelErrors(rawProcessDefinition);
            const eventDefinitions = parseEventDefinitionsFromObjectModel(rawProcessDefinition);
            process.laneSet = (0, index_2.parseProcessLaneSet)(rawProcess);
            process.sequenceFlows = (0, index_2.parseProcessSequenceFlows)(rawProcess);
            process.flowNodes = (0, index_2.parseProcessFlowNodes)(rawProcess, bpmnErrors, eventDefinitions);
            process.associations = parseAssociations(rawProcess);
            process.dataStoreReferences = parseDataStoreReferences(rawProcess);
            process.dataObjectReferences = parseDataObjectReferences(rawProcess);
            process.dataObjects = parseDataObjects(rawProcess);
            return process;
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                processModelId: processModelId,
            };
            throw error;
        }
    });
}
exports.parseProcesses = parseProcesses;
function parseAssociations(data) {
    const associationsRaw = (0, TypeFactory_1.getModelPropertyAsArray)(data, index_1.BpmnTags.CommonElement.Association);
    const noAssociationsFound = !((associationsRaw === null || associationsRaw === void 0 ? void 0 : associationsRaw.length) > 0);
    if (noAssociationsFound) {
        return [];
    }
    return associationsRaw.map((associationRaw) => {
        const association = (0, TypeFactory_1.createObjectWithCommonProperties)(associationRaw, index_1.Model.ProcessElements.Association);
        association.name = associationRaw.name;
        association.sourceRef = associationRaw.sourceRef;
        association.targetRef = associationRaw.targetRef;
        return association;
    });
}
function parseDataStoreReferences(data) {
    const referencesRaw = (0, TypeFactory_1.getModelPropertyAsArray)(data, index_1.BpmnTags.CommonElement.DataStoreReference);
    const noReferencesFound = !((referencesRaw === null || referencesRaw === void 0 ? void 0 : referencesRaw.length) > 0);
    if (noReferencesFound) {
        return [];
    }
    return referencesRaw.map((referenceRaw) => {
        const reference = (0, TypeFactory_1.createObjectWithCommonProperties)(referenceRaw, index_1.Model.ProcessElements.DataStoreReference);
        reference.name = referenceRaw.name;
        return reference;
    });
}
function parseDataObjectReferences(data) {
    const referencesRaw = (0, TypeFactory_1.getModelPropertyAsArray)(data, index_1.BpmnTags.CommonElement.DataObjectReference);
    const noReferencesFound = !((referencesRaw === null || referencesRaw === void 0 ? void 0 : referencesRaw.length) > 0);
    if (noReferencesFound) {
        return [];
    }
    return referencesRaw.map((referenceRaw) => {
        const reference = (0, TypeFactory_1.createObjectWithCommonProperties)(referenceRaw, index_1.Model.ProcessElements.DataObjectReference);
        reference.name = referenceRaw.name;
        reference.dataObjectRef = referenceRaw.dataObjectRef;
        return reference;
    });
}
function parseDataObjects(data) {
    const dataObjectsRaw = (0, TypeFactory_1.getModelPropertyAsArray)(data, index_1.BpmnTags.CommonElement.DataObject);
    const noDataObjectsFound = !((dataObjectsRaw === null || dataObjectsRaw === void 0 ? void 0 : dataObjectsRaw.length) > 0);
    if (noDataObjectsFound) {
        return [];
    }
    return dataObjectsRaw.map((dataObjectRaw) => {
        return (0, TypeFactory_1.createObjectWithCommonProperties)(dataObjectRaw, index_1.Model.ProcessElements.DataObject);
    });
}
function parseProcessModelErrors(data) {
    const processHasNoErrors = !data[index_1.BpmnTags.CommonElement.Error];
    if (processHasNoErrors) {
        return [];
    }
    const rawErrors = (0, TypeFactory_1.getModelPropertyAsArray)(data, index_1.BpmnTags.CommonElement.Error);
    return rawErrors.map((rawError) => {
        const newError = (0, TypeFactory_1.createObjectWithCommonProperties)(rawError, index_1.Model.GlobalElements.Error);
        newError.id = rawError.id;
        newError.code = rawError.errorCode;
        newError.name = rawError.name;
        newError.message = rawError['camunda:errorMessage'];
        return newError;
    });
}
function parseEventDefinitionsFromObjectModel(data) {
    const messageDefinitions = parseEventDefinitionTypeFromObjectModel(data, index_1.BpmnTags.CommonElement.Message, index_1.Model.Events.Definitions.MessageEventDefinition);
    const signalDefinitions = parseEventDefinitionTypeFromObjectModel(data, index_1.BpmnTags.CommonElement.Signal, index_1.Model.Events.Definitions.SignalEventDefinition);
    return Array.prototype.concat(messageDefinitions, signalDefinitions);
}
function parseEventDefinitionTypeFromObjectModel(data, tagName, typeFactory) {
    const rawDefinitions = (0, TypeFactory_1.getModelPropertyAsArray)(data, tagName);
    const collaborationHasNoMatchingDefinitions = !((rawDefinitions === null || rawDefinitions === void 0 ? void 0 : rawDefinitions.length) > 0);
    if (collaborationHasNoMatchingDefinitions) {
        return [];
    }
    return rawDefinitions.map((rawDefinition) => {
        const newDefinition = new typeFactory();
        newDefinition.id = rawDefinition.id;
        newDefinition.name = rawDefinition.name;
        return newDefinition;
    });
}
//# sourceMappingURL=ProcessParser.js.map